<template>
  <div class="table-scroll-wrapper" v-drag-scroll>
    <table class="table table-borderless table-border table-align">
    <thead>
      <tr>
        <th>
          <BkpsCheckBox @input="$emit('changeCheckAllRow', $event)" :value="checkAllRow" />
        </th>
        <template v-for="column in columns" >
          <th v-if="column.isCustomField" :key="column.key" class="nowrap">
            <strong>{{ column.label }}</strong>
            <span v-tooltip.top="buildCustomFieldDescritpion(column.description)" class="ml-1 text-strong">
              <InfoIcon size="1.5x"/>
            </span>
          </th>
          <th v-else :key="column.key + '_'" :title="column.description">
            {{ column.label }}
          </th>
        </template>
        <th v-if="false">Marcadores</th>
        <th v-if="false"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="ticket in tickets" :key="ticket.id">
        <td :class="buildClass(ticket)" :title="buildTitle(ticket)">
          <BkpsCheckBox v-model="ticket.checked" @input="$emit('changeCheckRow', $event)" />
        </td>
        <td v-for="column in columns" :key="column.key" class="nowrap">
          <template v-if="showBarcode(ticket, column)">
            <button class="btn btn-outline btn-sm" @click.prevent="copyBarcode(ticket.lastBoleto.codigoDeBarra)"
              v-tooltip.bottom="{ content: 'Clique para copiar' }">
              <BarcodeIcon />
            </button>
          </template>

          <template v-else>
            <span class="cell-value" :title="buildCellTitle(ticket, column)">{{ truncate(showTicketValue(ticket, column)) }}</span>
            <button v-if="hasValue(showTicketValue(ticket, column))" type="button"
              class="copy-icon" @click.prevent="copyText(showTicketValue(ticket, column))"
              title="Clique para copiar"
              >
              <CopyIcon size="1.2x" />
            </button>
          </template>
        </td>

        <td>
          <Dropdown title-dropdown="Opções" class="col-md ml-2 btn-sm btn-primary" position="right" floating>
            <ul class="mb-1 mt-1">
              <template v-if="$canDownload('cm-embarcador', 'download_boleto')">
                <li v-if="hasBoletoDocument(ticket)" class="dropdown-item" title="Clique para baixar o boleto"
                  @click="download(ticket.lastBoleto)">
                  Baixar boleto
                </li>
                <li v-else class="dropdown-item" title="Nenhum boleto disponível no momento"
                  style="cursor: not-allowed; color: #8A9EB5;">
                  Baixar boleto
                </li>
              </template>
              <!-- <li v-if="$withPolicy('cm-embarcador', 'download_docs')" title="Formulário de indicação do condutor infrator" -->
              <!--   class="dropdown-item" @click="downloadDocument(ticket.id, 'fici')"> -->
              <!--   Baixar FICI -->
              <!-- </li> -->
              <li v-if="$canDownload('cm-embarcador', 'download_demonstrativo')" title="Baixar demonstrativo"
                class="dropdown-item" @click="downloadDocument(ticket.id)">
                Baixar demonstrativo
              </li>
              <li>
                <a class="dropdown-item" :href="`/cm-embarcador/multas/${ticket.id}`" @click.prevent="showDetails(ticket)">
                  Detalhes
                </a>
              </li>
            </ul>
          </Dropdown>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
</template>

<script>
import GetUser from '@/mixins/GetUser'
import GetAccount from '@/mixins/GetAccount.vue'
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'

import GlobalLoading from '@/mixins/GlobalLoading'
import Dropdown from '@/components/shares/specialTag/Dropdown.vue'
import BarcodeIcon from '@/components/icons/BarcodeIcon.vue'

import { InfoIcon, CopyIcon } from 'vue-feather-icons'

export default {
  components: { BarcodeIcon, Dropdown, BkpsCheckBox, InfoIcon, CopyIcon },
  mixins: [GetUser, GetAccount, GlobalLoading],
  name: 'Table',
  props: {
    checkAllRow: { required: true, type: Boolean },
    columns: { required: true, type: Array },
    tickets: { required: true, type: Array }
  },
  data: () => ({}),
  methods: {
    showDetails(ticket) {
      this.$ls.set('show_cm-embarcador/multa', ticket, { minutes: 1 })
      this.$router.push(`/cm-embarcador/multas/${ticket.id}`)
    },
    openLoad() {
      this.openGlobalLoad()
    },
    closeLoad() {
      this.closeGlobalLoad()
    },
    associateLabels(ticket, labelIds) {
      this.axios.post(`maestro/tickets/${ticket.id}/set_label`, { label_ids: labelIds })
        .then(() => ticket.labelIds = labelIds)
    },
    hasBoletoDocument(ticket) {
      return ticket.lastBoleto
    },
    download(document) {
      this.openLoad()
      this.axios.v3.get(`/cm-embarcador/documentos/${document.id}/link?filename=${document.filename}`)
        .then(response => this.$parse.downloadByLink(response.data))
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeLoad())
    },
    downloadDocument(ticketId) {
      this.openLoad()
      this.axios.v3.get(`/cm-embarcador/multas/${ticketId}/latest_documents`)
        .then(response => {
          if (response.data)
            this.$parse.downloadByLink(response.data.url)
          else
            this.$notify.add('Nenhum demonstrativo disponível para este ticket.')
        })
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeLoad())
    },
    copyText(text, message) {
      message ||= `Conteúdo "${text}" copiado com sucesso!`
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$notify.add(message)
    },
    copyBarcode(barcode) {
      this.copyText(barcode, 'Código de barras copiado com sucesso!')
    },
    hasValue(value) {
      return value !== null && value !== undefined && String(value).trim() !== ''
    },
    buildCellTitle(ticket, column) {
      const value = this.showTicketValue(ticket, column)
      return this.hasValue(value) ? String(value) : ''
    },
    truncate(value, length = 20) {
      if (!this.hasValue(value))
        return value
      const text = String(value)
      return text.length > length ? `${text.slice(0, length)}…` : text
    },
    showTicketValue(ticket, column) {
      let value = null
      if (column.key.includes('.')) 
        value = ticket.dig(...column.key.split('.'))
      else 
        value = ticket[column.key]
      
      if (typeof column.method === 'function')
        return column.method(value)
      return value
    },
    showBarcode(ticket, column) {
      return column.key === 'lastBoleto.codigoDeBarra' && ticket.lastBoleto && ticket.lastBoleto.codigoDeBarra
    },
    buildCustomFieldDescritpion(description) {
      return description ? `Campo personalizado: ${description}` : 'Campo personalizado'
    },
    buildClass(ticket) {
      if (!ticket.messages)
        return

      const messages = ticket.messages.split(';').map(m => {
        const [type, message] = m.split(':')
        return { type, message }
      })

      if (messages.some(m => m.type === 'error'))
        return 'marker-red'
      else if (messages.some(m => m.type === 'warning'))
        return 'marker-yellow'
    },
    buildTitle(ticket) {
      if (!ticket.messages)
        return

      const messages = ticket.messages.split(';').map(m => {
        const [type, message] = m.split(':')
        return { type, message }
      })

      return messages.map(m => m.message).join('\n')
    }
  },
}
</script>

<style scoped>
.text-strong {
  color: #051B30;
}

.table-scroll-wrapper {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.table-scroll-wrapper > .table {
  width: auto;
  min-width: 100%;
  margin-bottom: 0;
}

.table-scroll-wrapper > .table thead th {
  white-space: nowrap;
}

.copy-icon {
  opacity: 0;
  margin-left: 4px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  vertical-align: middle;
  color: #051B30;
  transition: opacity 0.15s ease-in-out;
}

td:hover .copy-icon {
  opacity: 1;
}
</style>
